import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CURRENT_GIFT_TABLE, PROFILE_DATA, TOTAL_GIFT_TABLES } from 'constants/storage64';
import { decodeStorage } from 'functions/storageBase64';
import { getGiftTable } from 'services/giftTable';


const ByPass = () => {
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const profileData = decodeStorage(PROFILE_DATA);
      if (profileData) {
        const params = {
          customer_sears_id: profileData ? profileData.idClaro : '',
          page: 1
        };
        try {
          console.log('ByPass: ',params)
          const giftsTablesbypass = await getGiftTable(params);
          const giftTablesTotalbypass = giftsTablesbypass?.list?.length || 0;
          // console.log('giftsTables in bypass', giftsTablesbypass);
          // console.log('giftsTables count in bypass', giftTablesTotalbypass);
          if(giftTablesTotalbypass === 0){
            localStorage.setItem('giftTablesTotalbypass', 0);
            history.push('/mis-mesas');
          }else{
            history.push('/');
          }
        } catch (error) {
          // console.log('Fallo al obtener las mesas de regalos', error);
            localStorage.setItem('giftTablesTotalbypass', 0);
            history.push('/mis-mesas');
        }
      }
    };

    fetchData();
  }, [history]);

  return 0;
};

export default ByPass;
